import { Suspense, type ReactNode } from "react";
import { lazyWithRecovery } from "./runtime/lazyWithRecovery";
import { modelSlugs } from './components/marketing/modelRoutes';
import BlitzLoading from "./components/BlitzLoading";
import Homepage from "./components/Homepage";
import { appPath } from "./api";

const App = lazyWithRecovery(() => import("./App"));
const BlitzLinkPage = lazyWithRecovery(() => import("./components/marketing/BlitzLinkPage"));
const BlitzModelPage = lazyWithRecovery(() => import("./components/marketing/BlitzModelPage"));
const PublicationPage = lazyWithRecovery(() => import("./components/marketing/PublicationPage"));

function DeferredRoute({ children }: { children: ReactNode }) {
  return <Suspense fallback={<BlitzLoading label="Loading BlitzSynth…" className="blitz-loading--page"/>}>{children}</Suspense>;
}

export default function Entry() {
  const publicPath = window.location.pathname.replace(/\/$/, "");
  if (publicPath === appPath("/models")) return <DeferredRoute><BlitzLinkPage/></DeferredRoute>;
  const modelSlug = modelSlugs.find(slug => publicPath === appPath(`/models/${slug}`));
  if (modelSlug) return <DeferredRoute><BlitzModelPage slug={modelSlug}/></DeferredRoute>;
  const publication = ["/blog", "/careers", "/blog/reading-a-route", "/blog/early-access"].find(path => publicPath === appPath(path));
  if (publication) return <DeferredRoute><PublicationPage path={publication}/></DeferredRoute>;
  const root = window.location.pathname.replace(/\/$/, "") === appPath("/").replace(/\/$/, "");
  const authReturn = new URLSearchParams(window.location.search).has("auth");
  const workspaceLink = /^#(?:workspace\/|planner|molecule-detail)/.test(window.location.hash);
  // The public presentation makes no account requests. Existing workspace links
  // and provider callbacks continue through the server-authoritative auth gates.
  return root && !authReturn && !workspaceLink ? <Homepage/> : <DeferredRoute><App/></DeferredRoute>;
}
